module.exports = __webpack_public_path__ + "img/Mexico.0730eedb.png";